import { Col, Row, Typography } from 'darrius';

import { WhyUsData } from '../../../data/home/homeData';

import styles from './WhyUs.module.scss';

export const WhyUs = () => {
  return (
    <section className={styles['why-us']}>
      <div className={styles['all-content']}>
        <div className={`container ${styles.container}`}>
          <Col className="col-sm-12">
            <Row className="middle-sm space-between space-top">
              <Col className="col-sm-12 col-md-2 hide-mobile">
                <img
                  src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/partner-phone-sucess.svg`}
                  alt="Icone de celular"
                />
              </Col>
              <Col
                className={`col-sm-12 col-md-5 ${styles['space-bottom-desk']}`}
              >
                <Typography.Title size="3xl">
                  {WhyUsData.title}
                </Typography.Title>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 20,
                  }}
                >
                  <Typography.Text>
                    Aqui o cliente está a um clique de distância.
                  </Typography.Text>
                  <Typography.Text className="mt">
                    Tenha acesso a centenas de pedidos{' '}
                    <strong>na sua região</strong> e trabalhe com total
                    flexibilidade.
                  </Typography.Text>
                </div>
              </Col>
              <Col className="col-sm-12 col-md-5 center-sm">
                <img
                  src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/pages/home/partner-phone-sucess.png`}
                  alt="Imagem de solicitação no celular"
                />
              </Col>
            </Row>
          </Col>
        </div>
      </div>
    </section>
  );
};
